
// 测试者状态测验 个人分析报告 文本内容 （以接口提供为先，部分内容会被替换）
// 为方便处理，采用分段式分割处理 ^^


//候选人信息 替换真实信息
export const personalInfo = {
    baseInfo: {
        name: '李庆发',
        subject: '本科',
        sex: "男",
        major: "软件工程",
        age: '21',
        date: '2021-11-11',
        work: '北京',
    },
    statement: "本报告阅读权仅限于参与测评的本人及其他经授权人士，任何组织或个人在未经许可之下，不能擅自阅读、传播、复制或以其他形式使用本报告中的任何内容。"
}

//报告导读
export const reportIntroduction = { //心理测评导读
    content1: "世界卫生组织对“健康”的定义是：“所谓健康，不仅仅在于没有疾病，而且在于肉体、精神、社会各方面的正常状况。”",
    content2: "身体和心理的健康状态是所有人生活、学习、工作等一切社会活动的基础，对于测试者来说，同样如此。测试者保持身体和心理的健康状态，才能把握自己，适应环境，面向未来、积极进取、自强不息，显示出生命的价值。而信仰破灭、自卑、多疑、压抑、骄傲等都是不健康的表现，也会不同程度的影响测试者的身体健康。",
    content3: "大量的相关研究表明，除了身体健康，状态良好的测试者还需要拥有：",
    content4: "乐观向上的精神，情绪理智、稳定、愉快，心胸开朗豁达，遇事不斤斤计较，不为一点小事动火或忧郁在心。说话办事理智冷静，不冲动、随心所欲或急躁冒进。对生活自信、积极进取，很少苦闷失望、怨天尤人。",
    content5: "乐于与他人交往，希望获得真正的友谊和朋友。对朋友和他人总是抱着信任、理解、关心、友爱的态度，乐于助人，待人宽宏豁达，善于容忍他人的不足与过错，在小事上不斤斤计较，吹毛求疵，以牙还牙。办事讲信用、重名誉，不口是心非。对人以诚相待，适宜地暴露自己、显现自己，让别人了解自己，不伪装、掩饰自己。能够和各种人融洽相处，并能和少数人建立深厚的友谊。",
    content6: "良好的自我意识与意志，并且能与社会协调一致，善于适应环境，承受挫折。",
    content7: "根据上述标准，本报告主要从衡量测试者身心健康的核心的六大方面：工作倦怠、情绪稳定、积极心理、心理症状、人际和谐以及适应耐挫，对测试者最近的心理健康状态进行综合评估。"
}
export const reportIntroductionPer = {  //人格测评导读
    content1: "人格特质是指个体在不同的时间与情境中，保持自身相对一致的行为和认知方式，是一种稳定而持久的个人特性的综合表现。",
    content2: " 通过人格特质测评，受测者能更好的了解自己，并根据自身能力水平做到因势利导，明确自己的择业和发展方向；能够帮助受测者确定适合自己的目标，选择相应就业方向；能够为人力资源部门提供有价值的分析和人员分配建议；能够帮助管理者为受测者的发展提供适宜的路径指导，帮助其成为更好的自己。",
    content3: "报告中的各维度得分是将您的人格特质客观化的表现出来，但某个维度的分数高低，仅仅能够说明我们性格的特征，而并不说明或代表我们性格的优劣，以及我们未来成功可能性的大小。",
    content4: "我们未来能否获得成功，最重要的还在于我们能够发挥性格中的优势，回避自身的不足，以及自己的不懈努力。",
    content5: "本报告对受测人的人格特质进行了详细描述，结果没有“好”“坏”之分，仅作为自我了解使用。",
    content6: "人格特点的测试结果，可以帮助受测人自我提升，优化决策，促使其有效地发挥潜力；根据测评结果及建议，受测人可以根据自身特点，开展相应的角色调整，从而在实现自身价值、发挥性格优势的条件下促进协作与发展。",
    content7: "本测试可以广泛应用于心理咨询、人员选拔和职业指导等各个环节，并对人事决策和人事诊断提供个人心理素质定位的参考依据。"

}
export const reportIntroductionTeam = { //团队测评导读
    content1: "团队角色主要是指个体在具有相对合作性的团体中，所占据的具有自身特色与功能性的角色定位，也是团队其他成员对这一定位的认同和支持。",
    content11: "通过团队角色测评，能够帮助受测者更好的调整自身行为模式与认知状态，与所在的团体模式更加契合；能够根据受测者自身情况提供团队发展建议；能够帮助受测者与团队其他成员进行良性互动；能够帮助受测者选择适合自己的岗位职业，实现最佳的人职匹配和人企融合；能够帮助企业选拔人才，合理配置团队，为中高层管理人员的培养提供参考依据。",
    content2: "报告中的得分情况是将您的作答情况用数字表现出来，但某个维度的分数高低，仅仅能够说明本次测评或这一段时间里您的表现倾向，以及我们未来成功可能性的大小。我们未来能否获得成功，最重要的还在于我们能够发挥自身优势，配合团队成长，促进大家的共同发展。",
    content3: "本报告对受测人的团队角色进行了详细描述，结果没有“好”“坏”之分，仅作为自我了解使用。团队角色测试可以为受测人提供团队相处相关建议，并为受测人在团队中的角色定位提供指导意见，根据测评结果及建议，受测人可以根据自身特点与团队需求，开展相应的角色调整，从而在实现自身价值、发挥性格优势的条件下促进团队协作与发展。",
    content4: "本测试可以广泛应用于心理咨询、人员选拔和职业指导等各个环节，并对人事决策和人事诊断提供个人心理素质、团队角色定位的参考依据。",
    content5: "",
}
export const reportIntroductionBehavior = { //潜力行为测评
    content1: "人才的胜任行为能够有效预测结果绩效，而人才潜力是胜任行为的有力支撑，并且展现了人才的发展潜力。潜力很难通过面试被观察到，且不容易培养。",
    content2: "这些指标通常会对人才未来工作的效率和质量产生关键影响，本测验是对人才工作效率进行预测的素质测评工具.",
}


//报告阅读注意事项
export const readingNotes = {
    content1: "本测评报告是根据测试者对测评问卷的回答自动生成，报告的准确性取决于测试者在问卷作答时的认真和诚实程度，以及测试者对自己的了解程度。",
    content2: "本报告中呈现的所有得分都是转化为“标准分”以后的分数，维度状态得分均以标准十分表示，标准十分含义如下： ",
    content3: "通常情况下，1－3分为低分，4－7分为中等分，8－10分为高分。分数不重要，重要的是分数对应的状态描述。其中，1-3分区间的低分描述和8-10分区间的高分描述就是测试者比较突出的状态特征，而3-7分区间的中分描述说明测试者与大多数人一样。",
    content4: "随着时间的改变，测试者的个人角色与生活环境可能发生变化，其心理及情绪状态也有可能发生相应的改变，因此本测评报告的有效期为6－12个月，12个月后建议重新测评。",
    content5: "这是一份测评报告，报告内容可能涉及到个人隐私，因此请妥善保管。",
    info: "1分，表示测试者在该项状态特征上优于1%的人;<br/>2分，表示测试者在该项状态特征上优于5%的人;<br/>&nbsp;&nbsp;&nbsp;&nbsp;3分，表示测试者在该项状态特征上优于10%的人；<br/>&nbsp;&nbsp;&nbsp;&nbsp;4分，表示测试者在该项状态特征上优于25%的人；<br/>&nbsp;&nbsp;&nbsp;&nbsp;5分，表示测试者在该项状态特征上优于40%的人；<br/>&nbsp;&nbsp;&nbsp;&nbsp;6分，表示测试者在该项状态特征上优于60%的人；<br/>&nbsp;&nbsp;&nbsp;&nbsp;7分，表示测试者在该项状态特征上优于75%的人；<br/>&nbsp;&nbsp;&nbsp;&nbsp;8分，表示测试者在该项状态特征上优于90%的人；<br/>&nbsp;&nbsp;&nbsp;&nbsp;9分，表示测试者在该项状态特征上优于95%的人；<br/>&nbsp;&nbsp;&nbsp;&nbsp;10分，表示测试者在该项状态特征上优于99%的人。"
}
export const readingNotesPer = {
    content1: "本测验采用由1-10的十级评分标准，其中维度题目平均分为5.5,1-3为低分特征，4-7为中分特征，8-10为高分特征。",
    content2: "在不同的维度中，根据受测者题目作答得分状态，评估个体在某类维度上的优势性，得分越高，表明此维度内容特性在受测者个性特质中表现越明显。",
    content3: "通常情况下，1-3分为低分特征，表示受测人此维度上表现较为缺乏，没有明显的倾向性。4-7分为中分特征，表示受测人在此维度上表现居中，不存在过高或者过低的得分情形，如果得分超过均分5.5，则表明受测人在此维度上具有少许的优势，具有一定的可塑性。8-10分为高分特征，表示受测人在此维度上表现存在优势，具有较为明显的倾向性和发展性。",
    content4: "这是一份测评报告，报告内容可能涉及到个人隐私，因此请妥善保管。"
}


//
export const chuangxin = {
    content1: "作为创新者，思想奔放，创新力极强，是工作集体中许多想法和建议的提议人，创新者是集体中的思想家，富有创造力与想象力，才华横溢，善于打破常规，且知识面广，能够解决困难的问题。在团队中，创新者通常表现出智商高和内省的特征，他/她的意见往往是首创的且具有支配性，倾向于采取激进的方法手段从根本上解决问题。",
    content2: "创新者富有闯劲，是集体中最富有想象力的也是最富有智慧的团队成员。如果工作陷入困境，很可能是创新者率先提出解决问题的方案。因此，要使一个集体具有开创性，最好的方法之一就是把创新者这种角色移植到群体中去，他/她通常能为团队的发展提供思想和点子。创新者是团队中的预言家和梦想家，往往是生活在未来的世界中，可能过多的陶醉于自我的创造力之中，他/她的想法有时也有些激进。",
    content3: "创新者对表扬和批评反应强烈，不善于接受别人对自己观点的批评。创新者的个性鲜明，细枝末节往往不在他的视野之内，不拘小节，缺乏人际交流的技巧。",
}



export const pageThree = {
    content1: "测试者心理健康状态测评从工作倦怠、情绪稳定、积极心理、心理症状、人际和谐和适应耐挫等六大维度，评估测试者心理健康状态的倾向性。",
    content2: "以下为" + personalInfo.baseInfo.name + "在各个维度的得分情况：",
    content3: "考虑到仅根据测评总分做出判断存在一定的风险，建议还需进一步结合测试者在各维度的具体表现进行综合分析，以便了解测试者的岗位胜任力情况。",
    content4: personalInfo.baseInfo.name + "在六大维度的总体状态特征分析如下：",
    content5: "通常情况下，测试者在六大维度上的得分均为高分，或均为低分的情况较少见，大部分测试者均有自己的高分特征和低分特征，请着重关注≥8分和≤3分的状态特征。"
}

export const behaviorPageThree = {
    content1: "测试者心理健康状态测评从工作倦怠、情绪稳定、积极心理、心理症状、人际和谐和适应耐挫等六大维度，评估测试者心理健康状态的倾向性。",
    content2: "以下为" + personalInfo.baseInfo.name + "在各个维度的得分情况：",
    content3: "考虑到仅根据测评总分做出判断存在一定的风险，建议还需进一步结合测试者在各维度的具体表现进行综合分析，以便了解测试者的胜任力状态。",
    content4: personalInfo.baseInfo.name + "在六大维度的总体状态特征分析如下：",
    content5: "通常情况下，测试者在六大维度上的得分均为高分，或均为低分的情况较少见，大部分测试者均有自己的高分特征和低分特征，请着重关注≥8分和≤3分的状态特征。"
}

export const pageFour = {
    content1: "通过对测试者的选择进行分析，得出其在心理健康状态二级维度上的得分。测验主要采用标准分对测评结果进行评价，具体分成三个等级（1-3分为低分、4-7分为中分、8-10分为高分），以下是测试者心理状态特点的整体剖面图：",
    SectionviewData: [
        {
            title1: "身体状态",
            title2: "身体状态",
            low: "身体状态不佳，存在一系列感到不适的躯体症状反应，例如睡眠质量差、注意力不集中、身体部位和器官不舒服甚至刺痛等症状",
            height: "身体健康，状态良好，不存在不舒服、虚弱或疾病的症状和感觉",
            value: '',
            $$hashKey: "object:8",
        },
        {
            title1: "精力充沛",
            title2: "精力充沛",
            low: "疲于应付各种事情，经常需要休息，专注力容易受外部环境影响",
            height: "习惯快节奏、忙碌。喜欢参与很多事情也不感到一丝疲倦",
            value: '',
            $$hashKey: "object:9",
        },
        {
            title1: "情绪稳定性",
            title2: "情绪稳定性",
            low: "情绪自控和调节能力差，对外部刺激反应强烈，压力下，容易自乱方寸，无法正常行事",
            height: "非常沉着冷静，不容易惊慌失措，压力情形下，没有强烈情绪",
            value: '',
            $$hashKey: "object:10",
        },
        {
            title1: "抑郁程度",
            title2: "抑郁程度",
            low: "容易感到内疚、悲伤、失望和孤独，容易受打击，经常情绪低落",
            height: "阳光、正能量，不容易感到悲伤，很少有被遗弃感",
            value: '',
            $$hashKey: "object:11",
        },
        {
            title1: "焦虑程度",
            title2: "焦虑程度",
            low: "容易感到危险和威胁，容易紧张、恐惧、担忧、不安、神经过敏",
            height: "心态平静、放松，不会总是担心事情可能会出问题",
            value: '',
            $$hashKey: "object:12",
        },
        {
            title1: "乐观积极",
            title2: "乐观积极",
            low: "忧心未来，总是预感事情会误入歧途，关注负面的部分",
            height: "预感事情会变好，关注事情积极的一面，对未来保持乐观的态度",
            value: '',
            $$hashKey: "object:13",
        },
        {
            title1: "进取性",
            title2: "进取性",
            low: "甘于平凡，貌似随遇而安，实则缺少奋斗的动力",
            height: "渴望有所建树，争取更大更好的发展，通常表现得好胜心强",
            value: '',
            $$hashKey: "object:14",
        },
        {
            title1: "自信心",
            title2: "自信心",
            low: "对自己的缺点耿耿于怀，总担心自己不够好或无法完成任务，害怕成为人群的焦点",
            height: "为自己感到骄傲，真心认为自己有能力完成任务或解决问题，通常有较强表现自我的欲望",
            value: '',
            $$hashKey: "object:15",
        },
        {
            title1: "持之以恒",
            title2: "持之以恒",
            low: "很难长久的坚持做一件事，遇到困难，很容易轻言放弃",
            height: "能长久的坚持下去，即便遇到困难或看不清未来时，也不会轻易放弃",
            value: '',
            $$hashKey: "object:16",
        },
        {
            title1: "偏执性",
            title2: "偏执性",
            low: "理念及思维方式偏执，常常出现固执己见、多疑敏感、好斗记仇等状态",
            height: "思维方式合情合理，不存在偏执、多疑等行为",
            value: '',
            $$hashKey: "object:17",
        },
        {
            title1: "精神状态",
            title2: "精神状态",
            low: "已出现一些较为严重的精神障碍的症状体验，如幻觉、妄想等",
            height: "心理健康状态良好，不存在精神障碍的感受和行为",
            value: '',
            $$hashKey: "object:18",
        },
        {
            title1: "亲切随和",
            title2: "亲切随和",
            low: "从不主动表示友好，让人有很强的距离感，显得个性强烈或冷漠",
            height: "主动、友好对待每一个人，显得彬彬有礼、热情大方，很少要求别人过多关照自己",
            value: '',
            $$hashKey: "object:19",
        },
        {
            title1: "合群性",
            title2: "合群性",
            low: "避免人群，感觉太闹，希望有更多的独处时间，要求一定要有个人空间",
            height: "喜欢与人相处，喜欢人多热闹的场合。有许多朋友",
            value: '',
            $$hashKey: "object:20",
        },
        {
            title1: "外向性",
            title2: "外向性",
            low: "性格内向、缄默，喜欢独处，社交范围一般局限于少部分亲密朋友",
            height: "好交际，待人友好，生气勃勃，善于言谈，喜欢投入大量时间与人相处",
            value: '',
            $$hashKey: "object:21",
        },
        {
            title1: "社会适应",
            title2: "社会适应",
            low: "通常被别人认为是慢热的，对新环境、陌生人的接受需要一段较长时间",
            height: "对接触新的、陌生的人或环境毫无心理负担，能快速融入，如鱼得水",
            value: '',
            $$hashKey: "object:22",
        },
        {
            title1: "应对方式",
            title2: "应对方式",
            low: "在重要时刻感觉紧张，无所适从，担心事情误入歧途，但无能为力",
            height: "在重要时刻保持镇静，应对得当，更少受到重大事件的影响",
            value: '',
            $$hashKey: "object:23",
        },
        {
            title1: "忍耐挫折",
            title2: "忍耐挫折",
            low: "遇到委屈无法自我化解，抱怨而不行动，容易在挫折情绪里无法自拔",
            height: "能够用平和的心态面对挫折问题并积极解决，不易被强烈的情绪所困扰",
            value: '',
            $$hashKey: "object:24",
        },
    ],
}



// WEBPACK FOOTER //
// ./src/views/report/config/three.js